import http from '@/utils/http'

export const loadPortables = (nodeID, type = 'portables') => http.get(`/kuiper/${nodeID}/plugins/${type}`)

export const loadAvailablePortables = (nodeID, type = 'portables') =>
  http.get(`/kuiper/${nodeID}/plugins/${type}/prebuild`)

export const createPortable = (nodeID, body = {}, type = 'portables') =>
  http.post(`/kuiper/${nodeID}/plugins/${type}`, body)

export const updatePortable = (nodeID, body = {}, type = 'portables') =>
  http.put(`/kuiper/${nodeID}/plugins/${type}/${body.name}`, body)

export const viewPortable = (nodeID, id, type = 'portables') => http.get(`/kuiper/${nodeID}/plugins/${type}/${id}`)

export const deletePortable = (nodeID, id, type = 'portables') => http.delete(`/kuiper/${nodeID}/plugins/${type}/${id}`)

export const registerFunc = (nodeID, name, body = {}) =>
  http.post(`/kuiper/${nodeID}/plugins/functions/${name}/register`, body)

export default {}
